export const toolSchemas = {
    parse: {
        description: 'Parses a FIX message and describes it in plain language',
        schema: {
            type: 'object',
            properties: {
                fixString: { type: 'string' },
            },
            required: ['fixString'],
        },
    },
    parseToJSON: {
        description: 'Parses a FIX message into JSON',
        schema: {
            type: 'object',
            properties: {
                fixString: { type: 'string' },
            },
            required: ['fixString'],
        },
    },
    verifyOrder: {
        description: 'Verifies order parameters before execution. verifyOrder must be called before executeOrder.',
        schema: {
            type: 'object',
            properties: {
                clOrdID: { type: 'string' },
                handlInst: {
                    type: 'string',
                    enum: ['1', '2', '3'],
                    description:
                        'Handling Instructions: 1=Automated Execution No Intervention, 2=Automated Execution Intervention OK, 3=Manual Order',
                },
                quantity: { type: 'string' },
                price: { type: 'string' },
                ordType: {
                    type: 'string',
                    enum: [
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                        'A',
                        'B',
                        'C',
                        'D',
                        'E',
                        'F',
                        'G',
                        'H',
                        'I',
                        'J',
                        'K',
                        'L',
                        'M',
                        'P',
                        'Q',
                        'R',
                        'S',
                    ],
                    description:
                        'Order Type: 1=Market, 2=Limit, 3=Stop, 4=StopLimit, 5=MarketOnClose, 6=WithOrWithout, 7=LimitOrBetter, 8=LimitWithOrWithout, 9=OnBasis, A=OnClose, B=LimitOnClose, C=ForexMarket, D=PreviouslyQuoted, E=PreviouslyIndicated, F=ForexLimit, G=ForexSwap, H=ForexPreviouslyQuoted, I=Funari, J=MarketIfTouched, K=MarketWithLeftOverAsLimit, L=PreviousFundValuationPoint, M=NextFundValuationPoint, P=Pegged, Q=CounterOrderSelection, R=StopOnBidOrOffer, S=StopLimitOnBidOrOffer',
                },
                side: {
                    type: 'string',
                    enum: ['1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'],
                    description:
                        'Side: 1=Buy, 2=Sell, 3=BuyMinus, 4=SellPlus, 5=SellShort, 6=SellShortExempt, 7=Undisclosed, 8=Cross, 9=CrossShort, A=CrossShortExempt, B=AsDefined, C=Opposite, D=Subscribe, E=Redeem, F=Lend, G=Borrow, H=SellUndisclosed',
                },
                symbol: { type: 'string' },
                timeInForce: {
                    type: 'string',
                    enum: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C'],
                    description:
                        'Time In Force: 0=Day, 1=GoodTillCancel, 2=AtTheOpening, 3=ImmediateOrCancel, 4=FillOrKill, 5=GoodTillCrossing, 6=GoodTillDate, 7=AtTheClose, 8=GoodThroughCrossing, 9=AtCrossing, A=GoodForTime, B=GoodForAuction, C=GoodForMonth',
                },
            },
            required: ['clOrdID', 'handlInst', 'quantity', 'price', 'ordType', 'side', 'symbol', 'timeInForce'],
        },
    },
    executeOrder: {
        description: 'Executes a verified order. verifyOrder must be called before executeOrder.',
        schema: {
            type: 'object',
            properties: {
                clOrdID: { type: 'string' },
                handlInst: {
                    type: 'string',
                    enum: ['1', '2', '3'],
                    description:
                        'Handling Instructions: 1=Automated Execution No Intervention, 2=Automated Execution Intervention OK, 3=Manual Order',
                },
                quantity: { type: 'string' },
                price: { type: 'string' },
                ordType: {
                    type: 'string',
                    enum: [
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                        'A',
                        'B',
                        'C',
                        'D',
                        'E',
                        'F',
                        'G',
                        'H',
                        'I',
                        'J',
                        'K',
                        'L',
                        'M',
                        'P',
                        'Q',
                        'R',
                        'S',
                    ],
                    description:
                        'Order Type: 1=Market, 2=Limit, 3=Stop, 4=StopLimit, 5=MarketOnClose, 6=WithOrWithout, 7=LimitOrBetter, 8=LimitWithOrWithout, 9=OnBasis, A=OnClose, B=LimitOnClose, C=ForexMarket, D=PreviouslyQuoted, E=PreviouslyIndicated, F=ForexLimit, G=ForexSwap, H=ForexPreviouslyQuoted, I=Funari, J=MarketIfTouched, K=MarketWithLeftOverAsLimit, L=PreviousFundValuationPoint, M=NextFundValuationPoint, P=Pegged, Q=CounterOrderSelection, R=StopOnBidOrOffer, S=StopLimitOnBidOrOffer',
                },
                side: {
                    type: 'string',
                    enum: ['1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'],
                    description:
                        'Side: 1=Buy, 2=Sell, 3=BuyMinus, 4=SellPlus, 5=SellShort, 6=SellShortExempt, 7=Undisclosed, 8=Cross, 9=CrossShort, A=CrossShortExempt, B=AsDefined, C=Opposite, D=Subscribe, E=Redeem, F=Lend, G=Borrow, H=SellUndisclosed',
                },
                symbol: { type: 'string' },
                timeInForce: {
                    type: 'string',
                    enum: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C'],
                    description:
                        'Time In Force: 0=Day, 1=GoodTillCancel, 2=AtTheOpening, 3=ImmediateOrCancel, 4=FillOrKill, 5=GoodTillCrossing, 6=GoodTillDate, 7=AtTheClose, 8=GoodThroughCrossing, 9=AtCrossing, A=GoodForTime, B=GoodForAuction, C=GoodForMonth',
                },
            },
            required: ['clOrdID', 'handlInst', 'quantity', 'price', 'ordType', 'side', 'symbol', 'timeInForce'],
        },
    },
    marketDataRequest: {
        description: 'Requests market data for specified symbols',
        schema: {
            type: 'object',
            properties: {
                mdUpdateType: {
                    type: 'string',
                    enum: ['0', '1'],
                    description: 'Market Data Update Type: 0=Full Refresh, 1=Incremental Refresh',
                },
                symbols: { type: 'array', items: { type: 'string' } },
                mdReqID: { type: 'string' },
                subscriptionRequestType: {
                    type: 'string',
                    enum: ['0', '1', '2'],
                    description:
                        'Subscription Request Type: 0=Snapshot, 1=Snapshot + Updates, 2=Disable Previous Snapshot + Update Request',
                },
                mdEntryTypes: {
                    type: 'array',
                    items: {
                        type: 'string',
                        enum: [
                            '0',
                            '1',
                            '2',
                            '3',
                            '4',
                            '5',
                            '6',
                            '7',
                            '8',
                            '9',
                            'A',
                            'B',
                            'C',
                            'D',
                            'E',
                            'F',
                            'G',
                            'H',
                            'I',
                            'J',
                            'K',
                            'L',
                            'M',
                            'N',
                            'O',
                            'P',
                            'Q',
                            'R',
                            'S',
                            'T',
                            'U',
                            'V',
                            'W',
                            'X',
                            'Y',
                            'Z',
                        ],
                    },
                    description:
                        'Market Data Entry Types: 0=Bid, 1=Offer, 2=Trade, 3=Index Value, 4=Opening Price, 5=Closing Price, 6=Settlement Price, 7=High Price, 8=Low Price, 9=Trade Volume, A=Open Interest, B=Simulated Sell Price, C=Simulated Buy Price, D=Empty Book, E=Session High Bid, F=Session Low Offer, G=Fixing Price, H=Electronic Volume, I=Threshold Limits and Price Band Variation, J=Clearing Price, K=Open Interest Change, L=Last Trade Price, M=Last Trade Volume, N=Last Trade Time, O=Last Trade Tick, P=Last Trade Exchange, Q=Last Trade ID, R=Last Trade Side, S=Last Trade Price Change, T=Last Trade Price Change Percent, U=Last Trade Price Change Basis Points, V=Last Trade Price Change Points, W=Last Trade Price Change Ticks, X=Last Trade Price Change Ticks Percent, Y=Last Trade Price Change Ticks Basis Points, Z=Last Trade Price Change Ticks Points',
                },
            },
            required: ['mdUpdateType', 'symbols', 'mdReqID', 'subscriptionRequestType'],
        },
    },
    getStockGraph: {
        description: 'Generates a price chart for a given symbol',
        schema: {
            type: 'object',
            properties: {
                symbol: { type: 'string' },
            },
            required: ['symbol'],
        },
    },
    getStockPriceHistory: {
        description: 'Returns price history for a given symbol',
        schema: {
            type: 'object',
            properties: {
                symbol: { type: 'string' },
            },
            required: ['symbol'],
        },
    },
    technicalAnalysis: {
        description:
            'Performs comprehensive technical analysis on market data for a given symbol, including indicators like SMA, EMA, RSI, Bollinger Bands, and trading signals',
        schema: {
            type: 'object',
            properties: {
                symbol: {
                    type: 'string',
                    description: 'The trading symbol to analyze (e.g., AAPL, MSFT, EURUSD)',
                },
            },
            required: ['symbol'],
        },
    },
};
